<!--<template>-->
<!--  <div ref="slider" class="swiper mySwiper">-->
<!--    <div  class="swiper-wrapper">-->
<!--      <div v-for="(item, index) in data" :key="index" class="swiper-slide">{{ item.title }}</div>-->
<!--    </div>-->
<!--  </div>-->
<!--</template>-->
<!--<script>-->
<!--import { Swiper } from 'swiper/swiper-bundle'-->
<!--import 'swiper/swiper-bundle.css'-->
<!--// import MtnAppsRepository from '../../repositories/MtnAppsRepository'-->
<!--import BundleSliderRepository from '../../repositories/BundleSliderRepository'-->
<!--export default {-->
<!--  data () {-->
<!--    return {-->
<!--      bundleRepo: new BundleSliderRepository(),-->
<!--      data: []-->
<!--    }-->
<!--  },-->
<!--  created () {-->
<!--  },-->
<!--  mounted () {-->
<!--    const temp = this-->
<!--    const swiper = new Swiper('.mySwiper', {-->
<!--      slidesPerView: 4.5,-->
<!--      slidesPerGroup: 4,-->
<!--      spaceBetween: 20,-->
<!--      on: {-->
<!--        slideChange (swiper) {-->
<!--          console.log(swiper.activeIndex)-->
<!--          temp.getApps(swiper.activeIndex)-->
<!--        },-->
<!--        slideChangeTransitionEnd (swiper) {-->
<!--          // console.log(swiper)-->
<!--        },-->
<!--        async init () {-->
<!--          await temp.getApps(0)-->
<!--        }-->
<!--      }-->
<!--    })-->
<!--  },-->
<!--  methods: {-->
<!--    async getApps (page) {-->
<!--      const response = await this.bundleRepo.getPage(page, 5)-->
<!--      for (let i = 0; i < response.data.data.length; i++) {-->
<!--        this.data.push(response.data.data[i])-->
<!--      }-->
<!--    }-->
<!--  }-->
<!--}-->
<!--</script>-->
<!--<style lang="scss">-->
<!--@import "src/assets/sass/main";-->
<!--</style>-->
<!--<style>-->
<!--.swiper {-->
<!--  position: relative;-->
<!--  width: 100%;-->
<!--  height: 320px;-->
<!--}-->
<!--.swiper-slide {-->
<!--  display: flex;-->
<!--  align-items: center;-->
<!--  justify-content: center;-->
<!--  border-radius: 18px;-->
<!--  font-size: 22px;-->
<!--  font-weight: bold;-->
<!--  color: #fff;-->
<!--}-->

<!--.swiper-slide:nth-child(1n) {-->
<!--  background-color: rgb(206, 17, 17);-->
<!--}-->

<!--.swiper-slide:nth-child(2n) {-->
<!--  background-color: rgb(0, 140, 255);-->
<!--}-->

<!--.swiper-slide:nth-child(3n) {-->
<!--  background-color: rgb(10, 184, 111);-->
<!--}-->

<!--.swiper-slide:nth-child(4n) {-->
<!--  background-color: rgb(211, 122, 7);-->
<!--}-->

<!--.swiper-slide:nth-child(5n) {-->
<!--  background-color: rgb(118, 163, 12);-->
<!--}-->

<!--.swiper-slide:nth-child(6n) {-->
<!--  background-color: rgb(180, 10, 47);-->
<!--}-->

<!--.swiper-slide:nth-child(7n) {-->
<!--  background-color: rgb(35, 99, 19);-->
<!--}-->

<!--.swiper-slide:nth-child(8n) {-->
<!--  background-color: rgb(0, 68, 255);-->
<!--}-->

<!--.swiper-slide:nth-child(9n) {-->
<!--  background-color: rgb(218, 12, 218);-->
<!--}-->

<!--.swiper-slide:nth-child(10n) {-->
<!--  background-color: rgb(54, 94, 77);-->
<!--}-->
<!--</style>-->

<!------------------------------- swiper js ---------------------------------->
<!------------------------------- vue card stack ----------------------------->
<!--<template>-->
<!--  <vue-card-stack :cards="cards" :stack-width="480" :card-width="320">-->
<!--    <template v-slot:card="{ card }">-->
<!--      <div-->
<!--        style="width: 100%; height: 100%;"-->
<!--        :style="{ background: card.background }"-->
<!--      ></div>-->
<!--    </template>-->
<!--  </vue-card-stack>-->
<!--</template>-->
<!--<script>-->
<!--import VueCardStack from 'vue-card-stack'-->
<!--export default {-->
<!--  components: {-->
<!--    VueCardStack-->
<!--  },-->
<!--  data () {-->
<!--    return {-->
<!--      cards: [-->
<!--        { background: 'blue' },-->
<!--        { background: 'red' },-->
<!--        { background: 'pink' },-->
<!--        { background: 'yellow' },-->
<!--        { background: 'green' }-->
<!--      ]-->
<!--    }-->
<!--  }-->
<!--}-->
<!--</script>-->
<!------------------------------- hand made  --------------------------------->
<!--<template>-->
<!--  <div class="cards-container">-->
<!--    <div :style="{zIndex: index, top: `${index * 10}px`, left:  `${index * 10}px`}" v-for="(item, index) in 4" class="card" :key="index"></div>-->
<!--  </div>-->
<!--</template>-->
<!--<script>-->
<!--</script>-->
<!--<style scoped>-->
<!--.cards-container {-->
<!--  position: relative;-->
<!--}-->
<!--.card {-->
<!--  height: 300px;-->
<!--  width: 400px;-->
<!--  position: absolute;-->
<!--}-->
<!--.card:nth-child(1n) {-->
<!--  background: #E50019;-->
<!--}-->
<!--.card:nth-child(2n) {-->
<!--  background: #00DC5F;-->
<!--}-->
<!--.card:nth-child(3n) {-->
<!--  background: #FFCB05;-->
<!--}-->
<!--.card:nth-child(4n) {-->
<!--  background: #00678F;-->
<!--}-->
<!--</style>-->

<!--<template>-->
<!--  <swiper :modules="modules" :pagination="{ clickable: true }">-->
<!--    <swiper-slide>Slide 1</swiper-slide>-->
<!--    <swiper-slide>Slide 2</swiper-slide>-->
<!--    <swiper-slide>Slide 3</swiper-slide>-->
<!--  </swiper>-->
<!--</template>-->

<!--<script>-->
<!--import { Swiper, SwiperSlide } from 'vue-awesome-swiper'-->

<!--// import swiper module styles-->
<!--// more module style...-->

<!--export default {-->
<!--  components: {-->
<!--    Swiper,-->
<!--    SwiperSlide-->
<!--  }-->
<!--}-->
<!--</script>-->
<!--<template>-->
<!--  <carousel :items="3.5" :rtl="true" :loop="true">-->
<!--    <div>1</div>-->
<!--    <div>2</div>-->
<!--    <div>3</div>-->
<!--    <div>4</div>-->
<!--    <div>5</div>-->
<!--    <div>6</div>-->
<!--  </carousel>-->
<!--</template>-->
<!--<script>-->

<!--import carousel from 'vue-owl-carousel'-->

<!--export default {-->
<!--  components: { carousel }-->
<!--}-->

<!--</script>-->
<template>
  <div>
    <div ref="glide" class="glide">
      <div class="glide__track" data-glide-el="track">
        <ul class="glide__slides">
          <li class="glide__slide">0</li>
          <li class="glide__slide">1</li>
          <li class="glide__slide">2</li>
          <li class="glide__slide">3</li>
          <li class="glide__slide">4</li>
          <li class="glide__slide">5</li>
        </ul>
      </div>
      <div class="glide__arrows" data-glide-el="controls">
        <button class="glide__arrow glide__arrow--left" data-glide-dir="<">prev</button>
        <button class="glide__arrow glide__arrow--right" data-glide-dir=">">next</button>
      </div>
    </div>
  </div>
</template>
<script>
import Glide from '@glidejs/glide'
import '@glidejs/glide/dist/css/glide.theme.min.css'
import '@glidejs/glide/dist/css/glide.core.min.css'
export default {
  mounted () {
    new Glide('.glide', {
      type: 'carousel',
      bound: true,
      perView: 4.5
    }).mount()
  }
}
</script>
<!--<style scoped>-->
<!--@import '../assets/styles/glide/glide.core.min.css';-->
<!--</style>-->
